module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_08.f653fb3c.svg";